import MuiTabs from "@mui/material/Tabs";
import MuiTab from "@mui/material/Tab";

const Tabs = MuiTabs;
const Tab = MuiTab;

export default Tabs;
export { Tab };
